import type { ThemeDefinition } from 'vuetify'

export const staticPrimaryColor = '#334155'
export const staticPrimaryDarkenColor = '#1E293B'

export const themes: Record<string, ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      // Primary brand colors - Graphite slate
      'primary': staticPrimaryColor,
      'on-primary': '#FFFFFF',
      'primary-darken-1': staticPrimaryDarkenColor,
      'primary-lighten-1': '#64748B',

      // Secondary - Lighter slate accent
      'secondary': '#64748B',
      'secondary-darken-1': '#475569',
      'secondary-lighten-1': '#94A3B8',
      'on-secondary': '#FFFFFF',

      // Semantic colors
      'success': '#10B981',
      'on-success': '#FFFFFF',
      'info': '#3B82F6',
      'on-info': '#FFFFFF',
      'warning': '#F59E0B',
      'on-warning': '#FFFFFF',
      'error': '#EF4444',
      'on-error': '#FFFFFF',

      // Surface & backgrounds
      'background': '#F6F7F9',
      'on-background': '#0F172A',
      'surface': '#FFFFFF',
      'on-surface': '#0F172A',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#F1F5F9',
      'on-surface-variant': '#64748B',

      // Grey scale
      'grey': '#64748B',
      'grey-darken-1': '#475569',
      'grey-lighten-1': '#94A3B8',
      'grey-lighten-2': '#CBD5E1',
      'grey-lighten-3': '#E2E8F0',
      'grey-lighten-4': '#F1F5F9',
      'grey-lighten-5': '#F8FAFC',

      // Component specific
      'perfect-scrollbar-thumb': '#CBD5E1',
      'track-bg': '#F1F5F9',
    },

    variables: {
      'border-color': '#E2E8F0',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.60,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#212529',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#F5F5F5',
      'theme-on-code': '#000000',
    },
  },

  dark: {
    dark: true,
    colors: {
      // Primary brand colors - Lighter shades for dark mode
      'primary': '#94A3B8',
      'on-primary': '#0F172A',
      'primary-darken-1': '#64748B',
      'primary-lighten-1': '#CBD5E1',

      // Secondary - Lighter slate accent
      'secondary': '#CBD5E1',
      'secondary-darken-1': '#94A3B8',
      'secondary-lighten-1': '#E2E8F0',
      'on-secondary': '#0F172A',

      // Semantic colors - Adjusted for dark mode
      'success': '#34D399',
      'on-success': '#FFFFFF',
      'info': '#60A5FA',
      'on-info': '#FFFFFF',
      'warning': '#FBBF24',
      'on-warning': '#FFFFFF',
      'error': '#F87171',
      'on-error': '#FFFFFF',

      // Surface & backgrounds - Dark graphite palette
      'background': '#0B0F17',
      'on-background': '#F1F5F9',
      'surface': '#151A23',
      'on-surface': '#F1F5F9',
      'surface-bright': '#232A36',
      'surface-variant': '#151A23',
      'on-surface-variant': '#94A3B8',

      // Grey scale
      'grey': '#94A3B8',
      'grey-darken-1': '#CBD5E1',
      'grey-lighten-1': '#64748B',
      'grey-lighten-2': '#475569',
      'grey-lighten-3': '#2A3240',
      'grey-lighten-4': '#151A23',
      'grey-lighten-5': '#0B0F17',

      // Component specific
      'perfect-scrollbar-thumb': '#3A4353',
      'track-bg': '#232A36',
    },

    variables: {
      'border-color': '#2A3240',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.60,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.10,
      'hover-opacity': 0.08,
      'focus-opacity': 0.12,
      'selected-opacity': 0.12,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.10,
      'theme-kbd': '#212529',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#343434',
      'theme-on-code': '#CCCCCC',
    },
  },
}

export default themes
